import { z } from 'zod';
// ---------------------------------------------------------------------------
// 매니저-사용자 배정 생성 스키마
// ---------------------------------------------------------------------------
export const CreateAssignmentSchema = z.object({
    managerId: z.string().uuid('유효한 매니저 ID가 아닙니다'),
    userId: z.string().uuid('유효한 사용자 ID가 아닙니다'),
});
//# sourceMappingURL=assignment.js.map